import {
  FormControl,
  Grid,
  InputLabel,
  Select,
  Stack,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Button,
  Pagination,
  Box,
  LinearProgress,
  Typography,
  Checkbox,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import {
  useGetCandidatosQuery,
  useLazyGetInscricaoFiltroQuery,
} from "../../shared/features/api/inscricao/inscricaoSlice";
import { IInscricao } from "shared/features/api/inscricao/types";
import { useAvaliarPreRequisitosInscricoesMutation, useAvaliarPreRequisitosTodasInscricoesMutation } from "shared/features/api/avaliacao/avaliacaoSlice";
import { toast } from "react-toastify";
import { IAvaliarPreRequisitosInterface } from "shared/features/api/avaliacao/type";
import { parseSituacaoInscricao, parseStatusEtapa } from "shared/utils/enumsParser";
import { FormFilter } from "components/FormFilter";
import { useGetEdicaoAtualQuery } from "shared/features/api/edicao/edicaoSlice";
import { Export } from "components/ExportarExcel";

export const Registers: React.FC = () => {
  const [hideData, setHideData] = useState(false);
  
  const handleRetry = () => {
  setIsPageLoading(true);
  setServerError(null);
  setHideData(true);
    let nomeOuEmailLink = debouncedNomeOuEmail === "" ? "" : `&nomeOuEmail=${debouncedNomeOuEmail.trim()}`;
    let situacaoLink = situacao === "" ? "" : `&situacao=${situacao}`;
    let edicaoLink = edicao === null ? "" : `&edicao=${edicao}`;
    let etapaLink = etapa === "" ? "" : `&etapa=${etapa}`;
    let statusEtapaLink = statusEtapa === "" ? "" : `&statusEtapa=${statusEtapa}`;
    let trilhaLink = trilha === "" ? "" : `&trilha=${trilha}`;
    let sortLink = sort === "" ? "" : `&sort=${sort}`;
    let orderLink = order === null ? "" : `&order=${order}`;
    let datas: string = nomeOuEmailLink + situacaoLink + edicaoLink + etapaLink + statusEtapaLink + trilhaLink + sortLink + orderLink;
    getInscricaoFiltro({ url: `pagina=${page}&tamanho=20${datas}` })
      .unwrap()
      .then(() => {
        setIsPageLoading(false);
        setHideData(false);
      })
      .catch((err) => {
        setIsPageLoading(false);
        setHideData(false);
        setServerError("Erro ao buscar inscrições. O servidor está indisponível. Fale com o suporte se o problema persistir.");
        const msg = err?.data?.message || err?.error || JSON.stringify(err);
        toast.error(`Erro ao buscar inscrições: ${msg}`);
        console.error('Erro ao buscar inscrições:', err);
      });
  };
  const [serverError, setServerError] = useState<string | null>(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const navigate = useNavigate();
  const [page, setPage] = useState(() => {
    const saved = localStorage.getItem('candidatosPage');
    return saved ? parseInt(saved, 10) : 0;
  });
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState(0);

  const [getInscricaoFiltro, { data: inscricoes, isLoading: isLoadingFiltro }] = useLazyGetInscricaoFiltroQuery();
  const { data: candidatos, isLoading: isLoadingCandidatos } = useGetCandidatosQuery(
    { pagina: page },
    { refetchOnMountOrArgChange: true }
  );
  const { data: edicaoAtual } = useGetEdicaoAtualQuery();

  const [isAvaliando, setIsAvaliando] = useState<boolean>(false);
  const [idsSelecionados, setIdsSelecionados] = useState<number[]>([]);
  const [avaliarTodasInscricoes, { isLoading: carregandoTodasAvaliacoes }] = useAvaliarPreRequisitosTodasInscricoesMutation();
  const [avaliarInscricoesSelecionadas, { isLoading: carregandoAvaliacoesSelecionadas }] = useAvaliarPreRequisitosInscricoesMutation();
  const [nomeOuEmail, setNomeOuEmail] = useState("");
  const [debouncedNomeOuEmail, setDebouncedNomeOuEmail] = useState("");
  const [edicao, setEdicao] = useState("");
  const [trilha, setTrilha] = useState("");
  const [etapa, setEtapa] = useState("");
  const [statusEtapa, setStatusEtapa] = useState("");
  const [situacao, setSituacao] = useState("");

  const formFilterProps = {
    edicao: edicao,
    setEdicao: setEdicao,
    etapa: etapa,
    setEtapa: setEtapa,
    statusEtapa: statusEtapa,
    setStatusEtapa: setStatusEtapa,
    situacao: situacao,
    setSituacao: setSituacao,
    trilha: trilha,
    setTrilha: setTrilha
  }

  useEffect(() => {
    if (edicaoAtual) {
      setEdicao(edicaoAtual.nome)
    }
  }, [edicaoAtual])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedNomeOuEmail(nomeOuEmail);
      if (nomeOuEmail === "") {
        setIsPageLoading(true);
        getInscricaoFiltro({ url: `pagina=0&tamanho=20` })
          .unwrap()
          .then(() => setIsPageLoading(false))
          .catch(() => setIsPageLoading(false));
        setPage(0);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [nomeOuEmail, getInscricaoFiltro]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null;
    let timeoutCleared = false;
    const comFiltro =
      (!!debouncedNomeOuEmail && debouncedNomeOuEmail !== "") ||
      (!!situacao && situacao !== "") ||
      (!!edicao && edicao !== "") ||
      (!!etapa && etapa !== "") ||
      (!!statusEtapa && statusEtapa !== "") ||
      (!!trilha && trilha !== "") ||
      (!!sort && sort !== "") ||
      (order !== null && order !== 0);

    if (comFiltro) {
      setIsPageLoading(true); 
      setServerError(null);
      let nomeOuEmailLink = debouncedNomeOuEmail === "" ? "" : `&nomeOuEmail=${debouncedNomeOuEmail.trim()}`;
      let situacaoLink = situacao === "" ? "" : `&situacao=${situacao}`;
      let edicaoLink = edicao === null ? "" : `&edicao=${edicao}`;
      let etapaLink = etapa === "" ? "" : `&etapa=${etapa}`;
      let statusEtapaLink = statusEtapa === "" ? "" : `&statusEtapa=${statusEtapa}`;
      let trilhaLink = trilha === "" ? "" : `&trilha=${trilha}`;
      let sortLink = sort === "" ? "" : `&sort=${sort}`;
      let orderLink = order === null ? "" : `&order=${order}`;
      let datas: string = nomeOuEmailLink + situacaoLink + edicaoLink + etapaLink + statusEtapaLink + trilhaLink + sortLink + orderLink;

      getInscricaoFiltro({ url: `pagina=${page}&tamanho=20${datas}` })
        .unwrap()
        .then((data) => {
          if (timeoutId && !timeoutCleared) {
            clearTimeout(timeoutId);
            timeoutCleared = true;
          }
          if (!data || typeof data !== 'object' || !('elementos' in data)) {
            setServerError("Resposta inválida do servidor.");
          } else {
            setServerError(null);
            if (data.quantidadePaginas && page >= data.quantidadePaginas) {
              setPage(0);
            }
          }
          setIsPageLoading(false);
        })
        .catch((err) => {
          if (timeoutId && !timeoutCleared) {
            clearTimeout(timeoutId);
            timeoutCleared = true;
          }
          setIsPageLoading(false);
          setServerError("Erro ao buscar inscrições. O servidor está indisponível. Fale com o suporte se o problema persistir.");
          const msg = err?.data?.message || err?.error || JSON.stringify(err);
          toast.error(`Erro ao buscar inscrições: ${msg}`);
          console.error('Erro ao buscar inscrições:', err);
        });

      timeoutId = setTimeout(() => {
        setIsPageLoading(false);
        setServerError("Tempo de resposta excedido. O servidor pode estar lento ou indisponível.");
      }, 60000);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [debouncedNomeOuEmail, situacao, edicao, etapa, statusEtapa, trilha, sort, order, page, getInscricaoFiltro]);

  useEffect(() => {
    localStorage.setItem('candidatosPage', String(page));
  }, [page]);

  useEffect(() => {
    setIsPageLoading(true);
  }, [page]);

  useEffect(() => {
    const comFiltro =
      (!!debouncedNomeOuEmail && debouncedNomeOuEmail !== "") ||
      (!!situacao && situacao !== "") ||
      (!!edicao && edicao !== "") ||
      (!!etapa && etapa !== "") ||
      (!!statusEtapa && statusEtapa !== "") ||
      (!!trilha && trilha !== "") ||
      (!!sort && sort !== "") ||
      (order !== null && order !== 0);

    if (comFiltro) {
      if (!isLoadingFiltro) setIsPageLoading(false);
    } else {
      if (!isLoadingCandidatos) setIsPageLoading(false);
    }
    if (serverError) {
      setIsPageLoading(false);
    }
  }, [isLoadingCandidatos, isLoadingFiltro, serverError, debouncedNomeOuEmail, situacao, edicao, etapa, statusEtapa, trilha, sort, order]);

  const resetFiltro = () => {
    setIsPageLoading(true);
    setNomeOuEmail("");
    setDebouncedNomeOuEmail(""); 
    setSituacao("");
    setEdicao(edicaoAtual?.nome ?? "");
    setEtapa("");
    setStatusEtapa("");
    setTrilha("");
    setPage(0);
    setSort("");
    setOrder(0);
    getInscricaoFiltro({ url: `pagina=0&tamanho=20` })
      .unwrap()
      .then(() => setIsPageLoading(false))
      .catch(() => setIsPageLoading(false));
  };

  const baseColumns = [
    {
      field: "nome",
      headerName: "Candidato",
      minWidth: 200,
      flex: 2,
      renderCell: (params: any) => {
        const nome = params.row.nome?.trim() || "";
        const email = params.row.email || "";

        const partes = nome.split(" ");
        const iniciais =
          (partes[0]?.[0]?.toUpperCase() || "") + (partes[1]?.[0]?.toUpperCase() || "");

        return (
          <Box display="flex" alignItems="center" width="100%" overflow="hidden">
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                bgcolor: "primary.main",
                color: "white",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                mr: 1.5,
              }}
            >
              {iniciais}
            </Box>

            <Box
              sx={{
                overflow: "hidden",
                minWidth: 0,
                flex: 1,
              }}
              title={`${nome}\n${email}`}
            >
              <Typography fontSize={14} noWrap>
                {nome}
              </Typography>
              <Typography fontSize={12} noWrap>
                {email}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "situacao",
      headerName: "Situação",
      minWidth: 140,
      flex: 1,
    },
    {
      field: "statusEtapa",
      headerName: "Etapa",
      minWidth: 160,
      flex: 1,
      renderCell: (params: any) => (
        <Box>
          <Typography fontSize={14}>{params.row.etapa}</Typography>
          <Typography fontSize={12}>{params.row.statusEtapa}</Typography>
        </Box>
      ),
    },
    {
      field: "primeiraOpcaoTrilha",
      headerName: "Trilhas (1° | 2°)",
      minWidth: 160,
      flex: 1,
      sortable: true,
      renderCell: (params: any) => {
        const primeira = params.row.primeiraOpcaoTrilha;
        const segunda = params.row.segundaOpcaoTrilha;
        return (
          <Box>
            <Typography fontSize={14}>{primeira} {primeira && segunda ? " | " : ""} {segunda}</Typography>
          </Box>
        );
      }
    },
    {
      field: "edicao",
      headerName: "Edição",
      minWidth: 140,
    },
    {
      field: "acoes",
      headerName: "Detalhes",
      width: 140,
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => {
            navigate("/candidatos/curriculo", { state: params.row });
          }}
        >
          Detalhes
        </Button>
      ),
    },
  ];

  const columns = useMemo(() => {
    if (!isAvaliando) return baseColumns;

    const checkboxColumn = {
      field: "selecionar",
      headerName: "",
      width: 50,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        const avaliado = params.row.situacao !== "INSCRITO";
        const id = params.row.id;

        if (avaliado) return null;

        const isChecked = idsSelecionados.includes(id);

        const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event.target.checked) {
            setIdsSelecionados((prev) => [...prev, id]);
          } else {
            setIdsSelecionados((prev) => prev.filter((item) => item !== id));
          }
        };

        return <Checkbox checked={isChecked} onChange={handleCheck} />;
      }
    };
    return [checkboxColumn, ...baseColumns];
  },
    [isAvaliando, idsSelecionados]);

  const rows = () => {
    const comFiltro =
      (!!debouncedNomeOuEmail && debouncedNomeOuEmail !== "") ||
      (!!situacao && situacao !== "") ||
      (!!edicao && edicao !== "") ||
      (!!etapa && etapa !== "") ||
      (!!statusEtapa && statusEtapa !== "") ||
      (!!trilha && trilha !== "") ||
      (!!sort && sort !== "") ||
      (order !== null && order !== 0);
    const dataSource = comFiltro ? inscricoes : candidatos;
    if (!dataSource?.elementos || !Array.isArray(dataSource.elementos)) return [];
    return dataSource.elementos.map((dados) => {
      let etapaRow;
      const inscricaoEtapas = Array.isArray(dados.inscricaoEtapas) ? dados.inscricaoEtapas : [];
      if (etapa) {
        etapaRow = inscricaoEtapas.find(e => e.nomeEtapa === etapa);
      } else {
        const etapasValidas = inscricaoEtapas.filter(e => e.statusEtapa !== "AGUARDANDO");
        if (etapasValidas.length > 0) {
          etapaRow = etapasValidas.reduce((maior, atual) => {
            return atual.ordemEtapa > maior.ordemEtapa ? atual : maior;
          });
        } else {
          etapaRow = undefined;
        }
      }
      return {
        id: dados.idInscricao,
        nome: dados.candidato?.nome ?? "",
        email: dados.candidato?.email ?? "",
        primeiraOpcaoTrilha: dados.primeiraOpcaoTrilha ?? "",
        segundaOpcaoTrilha: dados.segundaOpcaoTrilha ?? "",
        situacao: parseSituacaoInscricao ? parseSituacaoInscricao(dados.situacao) : (dados.situacao ?? ""),
        etapa: etapaRow?.nomeEtapa ?? "-",
        statusEtapa: parseStatusEtapa ? parseStatusEtapa(etapaRow?.statusEtapa ?? "") : (etapaRow?.statusEtapa ?? "-"),
        edicao: dados.edicao ?? "",
        telefone: dados.candidato?.telefone ?? "",
        turno: dados.candidato?.formulario?.turno ?? "",
        estado: dados.candidato?.estado ?? "",
        acoes: dados,
      };
    });
  };

  const handleAvaliarTodasInscricoes = async () => {
    await toast.promise(
      avaliarTodasInscricoes().unwrap(),
      {
        pending: 'Carregando...',
        success: 'Inscrições selecionadas avaliadas com sucesso!',
        error: {
          render({ data }) {
            const message = (data as { data?: { message?: string } })?.data?.message;
            return message || "Erro ao avaliar as inscrições.";
          },
        }
      }
    );
    setIsAvaliando(false);
  };

  const handleAvaliarInscricoesSelecionadas = async () => {
    const ids: IAvaliarPreRequisitosInterface = { inscricoesIds: idsSelecionados }
    await toast.promise(
      avaliarInscricoesSelecionadas(ids).unwrap(),
      {
        pending: 'Carregando...',
        success: 'Inscrições selecionadas avaliadas com sucesso!',
        error: {
          render({ data }) {
            const message = (data as { data?: { message?: string } })?.data?.message;
            return message || "Erro ao avaliar as inscrições.";
          },
        }
      }
    );
    setIdsSelecionados([]);
    setIsAvaliando(false);
  }

  return (
  <Grid container spacing={2}>
      <Grid item xs={12}>
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={2}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setNomeOuEmail(nomeOuEmail);
            }}
            style={{ width: "100%" }}
          >
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="search-nome-ou-email">Pesquisar por nome ou email</InputLabel>
              <OutlinedInput
                id="search-nome-ou-email"
                label="Pesquisar por nome ou email"
                value={nomeOuEmail}
                onChange={(e) => setNomeOuEmail(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      type="submit"
                    >
                      <Search color="primary" />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </form>
          <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
            <FormFilter {...formFilterProps} />
            <Button
              fullWidth
              sx={{
                height: "3rem",
              }}
              variant="contained"
              onClick={resetFiltro}
            >
              Limpar
            </Button>
          </Box>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ mb: { xs: 1, sm: 0 } }}>
          Total de inscritos: <strong>{(inscricoes ? inscricoes.totalElementos : candidatos?.totalElementos) ?? 0}</strong>
        </Box>
        <Export color="primary" />
        {/* <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            justifyContent: { xs: "flex-start", sm: "flex-start" },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          {isAvaliando && (
            <>
              <Button
                sx={{
                  height: "3rem",
                  width: { xs: "100%", sm: "auto" },
                }}
                variant="contained"
                onClick={handleAvaliarInscricoesSelecionadas}
                disabled={idsSelecionados.length === 0 || carregandoAvaliacoesSelecionadas || carregandoTodasAvaliacoes}
              >
                Avaliar Selecionadas
              </Button>
              <Button
                sx={{
                  height: "3rem",
                  width: { xs: "100%", sm: "auto" },
                }}
                variant="contained"
                onClick={handleAvaliarTodasInscricoes}
                disabled={carregandoAvaliacoesSelecionadas || carregandoTodasAvaliacoes}
              >
                Avaliar Todas
              </Button>
            </>
          )}
          {/* feature sera movida para outro lugar
          <Button
            sx={{
              height: "3rem",
              width: { xs: "100%", sm: "auto" },
            }}
            variant="contained"
            color={isAvaliando ? "error" : "primary"}
            onClick={() => setIsAvaliando(!isAvaliando)}
            disabled={carregandoAvaliacoesSelecionadas || carregandoTodasAvaliacoes}
          >
            {isAvaliando ? "X" : "Avaliar Inscrições"}
          </Button>
        </Box> */}
      </Grid>
      <Grid item xs={12} sx={{ height: "calc(95vh - 211px)", width: "100%" }}>
        {isPageLoading ? (
          <LinearProgress />
        ) : serverError ? (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
            {isPageLoading && <LinearProgress sx={{ width: '100%', mb: 2 }} />}
            <Typography color="error" variant="h6" align="center" gutterBottom>
              {serverError}
            </Typography>
            <Typography color="textSecondary" align="center" gutterBottom>
              Tente novamente mais tarde ou entre em contato com o suporte.
            </Typography>
            <Button variant="contained" color="primary" onClick={handleRetry} sx={{ mt: 2 }} disabled={isPageLoading}>
              {isPageLoading ? 'Carregando...' : 'Tentar novamente'}
            </Button>
          </Box>
        ) : hideData ? (
          <LinearProgress />
        ) : (
          <DataGrid
            rows={rows() || []}
            columns={columns}
            pageSize={20}
            rowsPerPageOptions={[5]}
            onSortModelChange={(newSort) => {
              const sortField = newSort[0]?.field;
              const sortOrder = newSort[0]?.sort?.toUpperCase();
              setSort(sortField);
              setOrder(parseInt(sortOrder!));
            }}
            sx={{
              boxShadow: 2,
              '& .MuiDataGrid-cell': {
                fontSize: '14px',
              },
              '& .MuiDataGrid-columnHeaders': {
                fontSize: '16px',
                whiteSpace: 'nowrap',
              },
              '& .MuiDataGrid-row': {
                maxHeight: '40px',
              },
            }}
            hideFooter
          />
        )}
      </Grid>
      <Grid item xs={12} display="flex" justifyContent="center">
        <Pagination
          count={(inscricoes ? inscricoes.quantidadePaginas : candidatos?.quantidadePaginas) ?? 1}
          color="primary"
          size="small"
          onChange={(_, newPage) => {
            setPage(newPage - 1);
          }}
          page={page + 1}
        />
      </Grid>
    </Grid>
  );
};